import { useEffect, useState } from "react";
import { setAuthFailureHandler } from "./api/apiRequest";
import { getUser, initializeCsrf } from "./api/user-service";
import LoadingPage from "./pages/common/LoadingPage";
import CustomRoutes from "./router/CustomRoutes";
import { useAppDispatch } from "./store/hooks";
import { loginFailed, loginSuccess } from "./store/slices/auth-slice";

const App = () => {
  const [loading, setLoading] = useState(true);
  const dispatch = useAppDispatch();

  useEffect(() => {
    let isMounted = true;

    setAuthFailureHandler(() => dispatch(loginFailed()));

    const loadData = async () => {
      try {
        await initializeCsrf();
        const resp = await getUser();

        if (isMounted) {
          dispatch(loginSuccess(resp.data));
        }
      } catch (err) {
        if (isMounted) {
          dispatch(loginFailed());
        }
      } finally {
        if (isMounted) {
          setLoading(false);
        }
      }
    };

    loadData();

    return () => {
      isMounted = false;
      setAuthFailureHandler(undefined);
    };
  }, [dispatch]);

  return <div>{loading ? <LoadingPage /> : <CustomRoutes />}</div>;
};

export default App;
